import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import headerImage from "../Media/conference.jpg";
import "./Membership.scss";

const plans = [
  {
    name: "Quarterly Membership",
    price: "$600",
    unit: "+GST",
    perks: [
      "Membership for up to 5 members",
      "Exclusive invitations to member-only events",
      "Access to business networking forums",
      "Discounts on ANZEG Institute events and seminars",
    ],
  },
  {
    name: "Annual Membership",
    price: "$3,500",
    unit: "+GST",
    perks: [
      "Membership for up to 10+ members",
      "Invitations to tailored networking events",
      "Brand promotion across select events and publications",
      "Access to business forums and workshops",
      "Discounts on all ANZEG Institute events and educational webinars",
    ],
    featured: true,
  },
  {
    name: "Corporate Membership",
    price: "$7,500",
    unit: "+GST",
    perks: [
      "Membership for 30+ members at a regional and international level",
      "Exclusive invitations to high-profile events and summits",
      "Brand visibility across our digital channels and publications",
      "Access to executive business forums and leadership programs",
      "Special pricing for international business delegations and seminars",
    ],
  },
];

const faqs = [
  {
    q: "What are the membership fees used for?",
    a: "ANZEG membership fees are used to support operational costs, fund research, advocacy campaigns, and networking events. They enable the chamber to provide valuable resources to our members.",
  },
  {
    q: "What kind of events can I expect as a member?",
    a: "Members can attend a wide range of events, including business forums, leadership development workshops, and international business delegations. Exclusive members also get access to high-profile events and summits.",
  },
  {
    q: "How do I join or renew my membership?",
    a: "You can join or renew your membership by emailing info@anzeginstitute.org. We offer flexible payment options and membership plans tailored to suit businesses of all sizes.",
  },
];

const Membership = () => {
  return (
    <>
      <NavBar />
      <main className="membership">
        <header className="membership__hero">
          <div className="container membership__heroInner">
            <div className="membership__heroText">
              <span className="eyebrow">Membership</span>
              <h1 className="section-heading">ANZEG Membership</h1>
              <p className="lede">
                The ANZEG Institute Chamber of Commerce offers a gateway to
                valuable connections, business growth, and industry-leading
                insights through a strong, dynamic community of professionals
                across Egypt. Whether you're an entrepreneur, SME, or a large
                corporate, ANZEG Institute provides you with the tools and
                platform to enhance your business and expand your influence
                within your industry.
              </p>
            </div>
            <div className="membership__heroImage">
              <img src={headerImage} alt="ANZEG business forum in Cairo" />
            </div>
          </div>
        </header>

        <section className="membership__plans">
          <div className="container membership__plansGrid">
            {plans.map((plan) => (
              <div
                className={plan.featured ? "membership__plan membership__plan--featured" : "membership__plan"}
                key={plan.name}
              >
                {plan.featured && <span className="badge">Most Popular</span>}
                <h2>{plan.name}</h2>
                <p className="membership__price">
                  {plan.price} <span>{plan.unit}</span>
                </p>
                <ul className="marker-list">
                  {plan.perks.map((perk) => (
                    <li key={perk}>{perk}</li>
                  ))}
                </ul>
                <a href="mailto:info@anzeginstitute.org?subject=ANZEG%20Membership%20Enquiry" className="btn btn--filled">
                  Become a Member
                </a>
              </div>
            ))}
          </div>
        </section>

        <section className="membership__cta">
          <div className="container">
            <h2 className="section-heading section-heading--sm">
              Ready to grow your business with ANZEG?
            </h2>
            <p className="lede">
              Join today and unlock access to exclusive resources, networking
              opportunities, and advocacy tailored to help your business
              thrive.
            </p>
            <a href="mailto:info@anzeginstitute.org" className="btn btn--filled">Get in Touch</a>
          </div>
        </section>

        <section className="membership__faq">
          <div className="container">
            <span className="eyebrow">FAQ</span>
            <h2 className="section-heading section-heading--sm">Frequently Asked Questions</h2>
            <div className="membership__faqList">
              {faqs.map((item) => (
                <div className="membership__faqItem" key={item.q}>
                  <h3>{item.q}</h3>
                  <p className="lede">{item.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Membership;
